var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};

/*
* A function that given a set of arguments, returns a Promise, performing
* a corresponding SDMX Dataflow Structure Request (see getRequestArgs). 
*
* @memberOf SDMXJS
* @api public
* @tag promise
* @param {Object}
* @return {Promise}
*
* @example
* const args = {
*  ...
* }; // see getRequestArgs for args definition. No need to specify 'type' 
*
* SDMXJS.getDataflowStructure(args)
*   .then(data => successCallback(data))
*   .catch(error => errorCallback(error));
*/

import axios from 'axios';
import { DATAFLOW } from '../constants/types';
import { getRequestArgs } from '../getRequestArgs';
export var getDataflowStructure = function getDataflowStructure(args) {
  var _getRequestArgs = getRequestArgs(_extends({}, args, {
      type: DATAFLOW
    })),
    url = _getRequestArgs.url,
    headers = _getRequestArgs.headers,
    params = _getRequestArgs.params;
  return axios.get(url, {
    headers: headers,
    params: params
  }).then(function (res) {
    return res.data;
  });
};